import api from "./api";

// City service (CRUD)
// GET    /city
// GET    /city/:id
// POST   /city
// PATCH  /city/:id
// DELETE /city/:id

export async function getCities() {
  const res = await api.get("/city");
  return Array.isArray(res) ? res : [];
}

export async function getCitiesByCountryId(countryId) {
  if (countryId === undefined || countryId === null || countryId === "") {
    return [];
  }
  const idNum = Number(countryId);
  if (!Number.isInteger(idNum)) throw new Error("countryId must be an integer");
  const res = await api.get(`/city/country/${idNum}`);
  return Array.isArray(res) ? res : [];
}

export async function getCityById(cityId) {
  if (cityId === undefined || cityId === null || cityId === "") {
    throw new Error("cityId is required");
  }
  const idNum = Number(cityId);
  if (!Number.isInteger(idNum)) throw new Error("cityId must be an integer");
  return api.get(`/city/${idNum}`);
}

export async function createCity(payload) {
  return api.post("/city", payload || {});
}

export async function patchCity(cityId, payload) {
  const idNum = Number(cityId);
  if (!Number.isInteger(idNum)) throw new Error("cityId must be an integer");
  const body = { ...(payload || {}) };
  delete body.cityId;
  delete body.id;
  return api.patch(`/city/${idNum}`, body);
}

export async function deleteCity(cityId) {
  const idNum = Number(cityId);
  if (!Number.isInteger(idNum)) throw new Error("cityId must be an integer");
  return api.delete(`/city/${idNum}`);
}
